import { once } from 'ramda';
import { UserSyncArguments } from 'user-sync/index.types';

const ID = '42';
const IABid = [335];

export const createPixel = (consentData?: string | null): HTMLIFrameElement => {
  const iframe = document.createElement('iframe');
  iframe.style.display = 'none';
  if (consentData) {
    iframe.src = `https://sync.bfmio.com/sync_iframe?ifpl=5&ifg=4&id=Purch&gdpr=1&gc=${consentData}&gce=1`;
  } else {
    iframe.src = 'https://sync.bfmio.com/sync_iframe?ifpl=5&ifg=4&id=Purch&gdpr=0&gc=&gce=1';
  }

  return iframe;
};

export default once(({ userSyncPixelsManager, fastdom, context }: UserSyncArguments): void =>
  userSyncPixelsManager.create(context.gdprConsent, ID, IABid, () => {
    if (context.gdprConsent.consent?.gdprApplies) {
      const iframe = createPixel(context.gdprConsent.consent.tcString);
      fastdom.mutate(function userSyncBeachfrontCMPAddElement() {
        document.body.appendChild(iframe);
      });
    } else {
      const iframe = createPixel();
      fastdom.mutate(function userSyncBeachfrontAddElement() {
        document.body.appendChild(iframe);
      });
    }
  }),
);
